<template>
	<div>
		<div v-if="is_cart" class="bg-light-page px-3 pt-3 pb-1 rounded-6">
	    <div class="">
	      <div class="d-inline-block mr-2" v-for="special_request in getBeCart().special_request">
	        <img src="../../../../assets/img/icon/correct.png" class="position-relative d-inline-block align-top" width="10" style="top: 4px;">
	        <p class="mb-0 body-2-2 text-12 d-inline-block align-top">{{special_request.data.name}} <span v-if="special_request.note != ''">({{special_request.note}})</span></p>
	      </div>
	      <div class="row slim-grid-row" :class="{'mt-2':getBeCart().special_request.length > 0}">
	        <div class="col-6 mb-3" v-if="getBeCart().custom_time.check_in != ''">
	          <p class="mb-0 body-2 font-regular text-12">{{$t('hotel.special-request.request-check-in')}}</p>
	          <p class="mb-0 body-2-2 text-12">{{getBeCart().custom_time.check_in}} GMT+08</p>
	        </div>
	        <div class="col-6 mb-3" v-if="getBeCart().custom_time.check_out != ''">
	          <p class="mb-0 body-2 font-regular text-12">{{$t('hotel.special-request.request-check-out')}}</p>
	          <p class="mb-0 body-2-2 text-12">{{getBeCart().custom_time.check_out}} GMT+08</p>
	        </div>
	        <div class="col-12 mb-3" v-if="getBeCart().note != ''">
	          <p class="mb-0 body-2 font-regular text-12">{{$t('hotel.special-request.other-request')}}</p>
	          <p class="mb-0 body-2-2 text-12">{{getBeCart().note}}</p>
	        </div>
	      </div>
	    </div>
	  </div>
	</div>
</template>
<script>
	import {mapGetters} from 'vuex'

	export default{
		computed:{
			is_cart(){
				return (this.getBeCart().special_request.length > 0 || this.getBeCart().custom_time.check_in != '' || this.getBeCart().custom_time.check_out != '' || this.getBeCart().note != '') ? true : false
			}
		},
		methods:{
			...mapGetters(['getBeCart'])
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/mobile/specialRequestDetail.vue